import { forwardRef } from "react";

import Icon from "@/components/Icon";
import RawChevronDownIcon from "./RawChevronDownIcon.svg.jsx";

const ChevronDownIcon = forwardRef((props, ref) => {
  return <Icon ref={ref} SvgComponent={RawChevronDownIcon} {...props} />;
});

export default ChevronDownIcon;
